import { Route } from 'react-router-dom'
import {
  RotaEditVisitsScreen,
  RotaBuilderScreen,
  RotaRouteScreen,
  // PublishedRotaScreen,
  RotaManageVisitsScreen,
  RotaManageShiftsScreen,
  RotaEditShiftsScreen,
  RotaViewVisitsScreen,
  RotaViewShiftsScreen,
} from 'screens/Rostering/screens'
import { RotaMonitoringScreen } from 'screens/Rostering/screens/RotaMonitoringScreen'

const INDEX = 'rota'
const BUILDER = 'builder'
const PATTERNS = 'patterns'
// const PUBLISHED = 'published'
const VISITS = 'visits'
const SHIFTS = 'shifts'
const VISIT_EDIT = ':id/visit/edit'
const VISIT = ':id/visit'
const SHIFT_EDIT = ':id/shift/edit'
const SHIFT = ':id/shift'
const MONITORING = 'monitoring'

export const rotaRoutes = (
  <Route path={INDEX} element={<RotaRouteScreen />}>
    <Route path={BUILDER} element={<RotaBuilderScreen />} />
    <Route path={PATTERNS} element={<RotaManageVisitsScreen />} />
    {/* <Route path={PUBLISHED} element={<PublishedRotaScreen />} /> */}
    <Route path={VISITS} element={<RotaManageVisitsScreen />} />
    <Route path={SHIFTS} element={<RotaManageShiftsScreen />} />
    <Route path={SHIFT_EDIT} element={<RotaEditShiftsScreen />} />
    <Route path={SHIFT} element={<RotaViewShiftsScreen />} />
    <Route path={VISIT_EDIT} element={<RotaEditVisitsScreen />} />
    <Route path={VISIT} element={<RotaViewVisitsScreen />} />
    <Route path={MONITORING} element={<RotaMonitoringScreen />} />
  </Route>
)

export default rotaRoutes
